export const useBclickId = () => {
  const getBclickIdFromUrl = (): string | null => {
    if (typeof window === 'undefined') return null;
    const url = new URL(window.location.href);
    // Case-insensitive: ?bclickId and ?bclickid both occur on ad links.
    const bclick = [...url.searchParams.entries()].find(
      ([key, value]) => key.toLowerCase() === 'bclickid' && value,
    )?.[1];
    return bclick || url.searchParams.get('sub2');
  };

  return {
    getBclickId: getBclickIdFromUrl,
  };
};
